/**
 * 模組頁面代碼 :
 * 頁面說明 : 標題元件
 * @module features/main-frame/Header.jsx
 */

// ----- import from base components -----
import {React} from '../../../components/BaseComponent';

const Header = () => {
  return (
    <div className="header-container">
      <header className="c__header">
        <img className="img-fluid header-logo" src="/images/logo-CentryTrading_blk.svg" alt="世紀貿易股份有限公司" />
        <button
          className="btn btn-link header-menu"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNav"
          aria-controls="offcanvasNav"
        >
          <span className="material-symbols-outlined"> menu </span>
        </button>
      </header>
    </div>
  );
};

export default Header;
